import { Component, OnInit, Inject, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { InterpretationService } from '../../../../modules/interpretation/interpretation.service';
import { UserService } from '../../../services/user.service';
import { GenericIdName } from '../../../models/common-search-filters.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { PopupEndPoint } from '../../../../modules/inspection/models/create-inspection.model';
import { Condition, UpdateConditionCommentModel } from '../../../../modules/interpretation/models/interpretation.model';

@Component({
  selector: 'app-add-comment-modal',
  templateUrl: './add-comment-modal-component.html',
  styleUrls: ['./add-comment-modal-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddCommentModalComponent implements OnInit {
  private inspectionDetailId: number;
  private inspectionId: number;
  comment: string;
  savingComment = false;
  isInspector = false;
  isInterpreter = false;
  newComment = '';
  endPoint: PopupEndPoint;
  showplus: boolean = false;
  CompartTypeId: number;
  equipmentId: number;
  @Output() updateComment_: EventEmitter<any> = new EventEmitter();
  AddtoInterpretationComment: boolean;
  screenId: number;
  condition: Condition;
  constructor(
    private _dialogRef: MatDialogRef<AddCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialog: MatDialog,
    private _user: UserService) { }



  ngOnInit() {
    this.checkPermissions();
    if (this._data.comingFrom) {
      this.endPoint = this._data.comingFrom;
      this.newComment = this._data.comment;
      this.comment = this._data.comment;
      this.inspectionId = this._data.inspectionId
      this.equipmentId = this._data.equipmentId;
    } 
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      jobRoles => {
        jobRoles.forEach(role => {
          switch (role.Name) {
            case 'Inspectors':
              this.isInspector = true;
              break;
            case 'Interpreters':
            case 'Super User':
            case 'Administrator':
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case 'Customer Admin':
              this.isInspector = true;
              this.isInterpreter = true;
              break;
            case 'Undercarriage ONLY':
            case 'Undercarriage Inspector ONLY':
              this.isInspector = true;
              break;
          }
        });
      },
      error => {
        console.error(error);
        this._notify.error('Error', 'Unable to check your job roles. ');
      }
    );
  }
  updateComment() {
    this.savingComment = true;
    if (this.endPoint) {
      switch (this.endPoint) {
        case PopupEndPoint.InterpretationComponent:
          var request = new UpdateConditionCommentModel();
          request.InspectionId = this.inspectionId;
          request.NewComment = this.newComment;
          request.Condition = Condition.EqualiserBarTypeComment;
          request.EquipmentId = this.equipmentId;
          this._interp.updateConditionComment(request).subscribe((r: any) => {
            if (r.m_Item1) {
              this.success('Saved', r.m_Item2);
            }
          }, err => {
              this.error('Failed', 'Unable to save comment. Please contact TrackTreads support. ', err);
          });
        break;
        case PopupEndPoint.AddNewInspectionComponent:
            this._dialogRef.close({comment: this.newComment, endPoint: PopupEndPoint.AddNewInspectionComponent});
        break;
        case PopupEndPoint.CreateEditInspectionComponent:
            this._dialogRef.close({comment: this.newComment, endPoint: PopupEndPoint.CreateEditInspectionComponent});
        break;
      }
    } 
  }


  success(title: string, message: string) {
    this._notify.success(title, message);
    this.savingComment = false;
    this._dialogRef.close(true);
  }

  error(title: string, message: string, err: any) {
    this._notify.error(title, message);
    console.error(err);
    this.savingComment = false;
  }

  onNoClick(): void {
    this._dialogRef.close(false);
  }
}
